import { T } from "../lib/fc3i18n";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Mail } from "lucide-react";
import { api } from "../lib/api";
const DISCLAIMER = "The information and wellness suggestions provided by FemCare are for general educational and informational purposes only and do not constitute medical advice, diagnosis, or treatment. Always consult your gynecologist or a qualified healthcare professional before following any health-related advice or making decisions about your health.";
const col = "flex flex-col gap-3 text-[15px]";
const head = "text-[13px] font-semibold uppercase tracking-[0.14em] text-white mb-1";
const lnk = "text-[#F1E6EA] hover:text-white transition-colors";
export default function Footer() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");
  const subscribe = async e => {
    e.preventDefault();
    try {
      await api.post("/subscribe", {
        email
      });
      setStatus("Thanks — you're subscribed.");
      setEmail("");
    } catch {
      setStatus("Please enter a valid email address.");
    }
    setTimeout(() => setStatus(""), 4000);
  };
  return <footer className="bg-[#1E1A2B] text-[#F1E6EA] mt-24" data-testid="site-footer">
      <div className="max-w-[1240px] mx-auto px-5 lg:px-8 pt-16 pb-10">
        <div className="grid gap-12 md:grid-cols-12 pb-12 border-b border-[#45404A]">
          <div className="md:col-span-4 flex flex-col gap-5">
            <Link to="/" className="flex items-center gap-3" aria-label={T("FemCare home")}>
              <img src="/femcare-logo-v2.png" alt="" className="w-12 h-12 rounded-full object-cover" />
              <span className="text-[26px] text-white" style={{
              fontFamily: "var(--fc-serif)",
              fontWeight: 500
            }}>{T("FemCare")}</span>
            </Link>
            <p className="text-[15px] leading-relaxed max-w-sm">{T("Your health. Your rhythm. Your journey. Women's wellness for every stage of life.")}</p>
            <form onSubmit={subscribe} className="flex flex-col gap-2 max-w-sm" data-testid="newsletter-form">
              <label htmlFor="footer-email" className="text-[14px] font-semibold text-white">{T("Monthly wellness letter")}</label>
              <div className="flex gap-2">
                <input id="footer-email" type="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder={T("you@example.com")} className="flex-1 min-h-[48px] bg-[#35303A] border border-[#55505A] rounded-full px-5 text-[15px] text-white placeholder-[#B9AFB6] focus:outline-none focus:border-white" data-testid="newsletter-input" />
                <button type="submit" aria-label={T("Subscribe")} className="min-h-[48px] min-w-[48px] rounded-full bg-[#FFE9EF] text-[#2B2140] hover:bg-white inline-flex items-center justify-center" data-testid="newsletter-submit">
                  <ArrowRight className="w-5 h-5" />
                </button>
              </div>
              <p className="text-[13px] min-h-[18px] text-[#FFE9EF]" aria-live="polite">{status}</p>
            </form>
          </div>

          <div className="md:col-span-2"><div className={col}>
            <span className={head}>{T("Explore")}</span>
            <Link to="/features/cycle" className={lnk}>{T("Period health")}</Link>
            <Link to="/features/pregnancy" className={lnk}>{T("Pregnancy")}</Link>
            <Link to="/features/daughter-care" className={lnk}>{T("Daughter Care")}</Link>
            <Link to="/features/ai-coach" className={lnk}>{T("AI Wellness Companion")}</Link>
            <Link to="/fitness" className={lnk}>{T("FemCare Fitness")}</Link>
            <Link to="/community" className={lnk}>{T("Community")}</Link>
            <Link to="/pricing" className={lnk}>{T("Premium")}</Link>
          </div></div>

          <div className="md:col-span-2"><div className={col}>
            <span className={head}>{T("Free tools")}</span>
            <a href="https://tools.femcare.life/period-calculator/" className={lnk}>{T("Free Period Calculator")}</a>
            <a href="https://tools.femcare.life/period-calculator/hi/" className={lnk}>पीरियड कैलकुलेटर</a>
            <Link to="/blog" className={lnk}>{T("Learn")}</Link>
          </div></div>

          <div className="md:col-span-2"><div className={col}>
            <span className={head}>{T("Company")}</span>
            <Link to="/about" className={lnk}>{T("About")}</Link>
            <Link to="/contact" className={lnk}>{T("Contact")}</Link>
            <Link to="/support" className={lnk} data-testid="footer-support-link">{T("Help")}</Link>
            <Link to="/affiliate" className={lnk} data-testid="footer-affiliate-link">{T("Affiliate program")}</Link>
            <a href="mailto:support@femcare.life" className={`${lnk} inline-flex items-center gap-2`}><Mail className="w-4 h-4" aria-hidden="true" />{T("support@femcare.life")}</a>
          </div></div>

          <div className="md:col-span-2"><div className={col}>
            <span className={head}>{T("Get the app")}</span>
            <a href="https://apps.apple.com/us/app/femcare-life/id6781981749" target="_blank" rel="noopener noreferrer" data-testid="footer-app-store" aria-label={T("Download on the App Store")}>
              <img src="/app-store-badge.png" alt={T("Download on the App Store")} className="h-11 w-auto" />
            </a>
            <a href="https://play.google.com/store/apps/details?id=app.femcare.life&hl=en" target="_blank" rel="noopener noreferrer" data-testid="footer-play-store" aria-label={T("Get it on Google Play")}>
              <img src="/google-play-badge.png" alt={T("Get it on Google Play")} className="h-11 w-auto" />
            </a>
          </div></div>
        </div>

        <p className="pt-8 text-[13px] leading-relaxed text-[#B9AFB6] max-w-4xl">{T(DISCLAIMER)}</p>

        <div className="pt-6 flex flex-col md:flex-row justify-between gap-4 text-[13px] text-[#B9AFB6]">
          <p>{T("© 2026 Femcare Life Pvt. Ltd. All rights reserved.")}</p>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            <Link to="/privacy" className="hover:text-white" data-testid="footer-privacy-link">{T("Privacy")}</Link>
            <Link to="/terms" className="hover:text-white" data-testid="footer-terms-link">{T("Terms")}</Link>
            <Link to="/privacy" className="hover:text-white" data-testid="footer-cookies-link">{T("Cookies")}</Link>
            <Link to="/delete-account" className="hover:text-white">{T("Delete account")}</Link>
            <Link to="/admin/login" className="hover:text-white" data-testid="footer-admin-link">{T("Admin")}</Link>
          </div>
        </div>
      </div>
    </footer>;
}